'use strict';

UserProfileService.$inject = [
  '$timeout',
  'FirebaseUtil',
];

export function UserProfileService($timeout, FirebaseUtil) {
  const UserProfileService = {};

  // TODO: determine if UserProfileService.userProfileList is needed
  UserProfileService.userProfileList = [];

  UserProfileService.createProfile = function (profile) {
    return new Promise((resolve, reject) => {

      // requires id, email
      if (!profile.id) {
        throw new Error('Expected profile.id to exist!');
      }

      if (!profile.email && profile.provider === 'password') {
        throw new Error('Expected profile.email to exist!');
      } else if (!profile.displayName) {
        throw new Error('Expected profile.displayName to exist!');
      }

      const ref = FirebaseUtil.firebaseRef('users', profile.id);
      ref.set({
        displayName: profile.displayName || firstPartOfEmail(profile.email),
        firstName: profile.firstName || null,
        lastName: profile.lastName || null,
        email: profile.email,
        picture: profile.picture || null,
        publicAttrs: profile.publicAttrs || defaultPublicAttrs(),
      }, err => $timeout(() => err ? reject(err) : resolve(ref)));
    });
  };

  /**
   * Create a new user profile from a social login provider
   * @param user
   */
  UserProfileService.createSocialProfile = function (user) {
    const profile = {};

    profile.id = user.uid;
    profile.displayName = user[user.provider].displayName;
    profile.email = user.email || null;
    if (user[user.provider] && user[user.provider].cachedUserProfile) {
      profile.lastName = user[user.provider].cachedUserProfile.family_name || '';
      profile.firstName = user[user.provider].cachedUserProfile.given_name || '';
      profile.picture = user[user.provider].cachedUserProfile.picture;
    }

    return UserProfileService.createProfile(profile);
  };


  // Properties set to public by default.
  // Display name is always public so it om
  function defaultPublicAttrs() {
    return {
      displayName: true,
      joinedDate: true,
      firstName: false,
      lastName: false,
      email: false,
      picture: true,
    };
  }

  function firstPartOfEmail(email) {
    return ucfirst(email.substr(0, email.indexOf('@')) || '');
  }

  function ucfirst(str) {
    // credits: http://kevin.vanzonneveld.net
    str += '';
    const f = str.charAt(0).toUpperCase();
    return f + str.substr(1);
  }

  return UserProfileService;
}



// WEBPACK FOOTER //
// ./src/js/auth/services/UserProfileService.js